// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__gpCWX","paramInput":"JobSimulator_paramInput__12qqi","input":"JobSimulator_input__SlKTy"};